import { withClassName } from 'lp-hoc'

const Content = withClassName('content')('main')

export default Content
